// 261023 E3-P3j0 (P2) — «Cần kiểm lại»: tập mà giám khảo C2 CHƯA kiểm đúng bản hiện hành (người sửa tay sau lần kiểm, vắng biên lai, UNCHECKED). THUẦN (jest) — KHÔNG import antd / react.
// BE tính `episode.qualityReady` (chỉ chuỗi `qr1`); FE chỉ ĐỌC: không suy «sạch» từ count=0, không số tiền. Tập `needsRecheck` BE đã khoá đẩy (`eligibleForPush=false`) — dải chỉ nói vì sao + một nút «Kiểm lại»
// gọi ĐÚNG route chấm lại C2 đang có (`rejudgeC2`, MỘT tập mỗi lần, job nền). Nối sổ tiền cho chấm lại: TODO lát 3j2 (BE).
import type { WorkbenchEpisode, WorkbenchView } from '../../../types/adaptationWorkbench';
import { isRejudgeJob } from './rejudgeView';

export const RECHECK_LABEL = 'Kiểm lại';
const BUSY_REASON = 'Đang có việc chạy nền — đợi xong rồi bấm';
const RUNNING_REASON = 'Đang kiểm lại — đợi xong';
const WRITER_UNKNOWN_REASON = 'Không rõ model đã viết bản này — viết lại tập để máy kiểm';

export interface RecheckStrip {
  /** Mọi tập cần kiểm lại (tăng dần). */
  episodes: number[];
  /** Tập sẽ kiểm khi bấm (tập đầu chấm lại được). */
  target: number;
  /** MỘT câu cho người dùng. */
  sentence: string;
  disabled: boolean;
  disabledReason: string | null;
}

type Eps = ReadonlyArray<Pick<WorkbenchEpisode, 'ep' | 'written' | 'qualityReady' | 'rejudge'>>;

const listOf = (ns: number[]): string => ns.join(', ');

/** Câu dải. Tất cả do người sửa ⇒ «Bạn vừa sửa»; tất cả do máy chưa kiểm xong ⇒ «chưa kiểm xong»; lẫn ⇒ câu chung. */
export const recheckSentence = (rows: Array<{ ep: number; stale: boolean }>): string => {
  const eps = rows.map((r) => r.ep);
  const allStale = rows.every((r) => r.stale);
  const noneStale = rows.every((r) => !r.stale);
  if (rows.length === 1) {
    return allStale ? `Bạn vừa sửa tập ${eps[0]} — máy cần kiểm lại trước khi đẩy` : `Máy chưa kiểm xong tập ${eps[0]} — cần kiểm lại trước khi đẩy`;
  }
  if (allStale) return `Bạn vừa sửa tập ${listOf(eps)} — máy cần kiểm lại từng tập trước khi đẩy`;
  if (noneStale) return `Máy chưa kiểm xong tập ${listOf(eps)} — cần kiểm lại từng tập trước khi đẩy`;
  return `Tập ${listOf(eps)} cần kiểm lại trước khi đẩy`;
};

export const recheckStripOf = (workbench: { episodes?: Eps | null; jobs?: Pick<WorkbenchView['jobs'], 'running'> | null } | null | undefined): RecheckStrip | null => {
  const need = (workbench?.episodes ?? [])
    .filter((e) => e.written === 'draft' && e.qualityReady?.needsRecheck === true)
    .map((e) => ({ ep: e.ep, stale: e.qualityReady?.c2 === 'STALE', canRejudge: e.rejudge?.available !== false }))
    .sort((a, b) => a.ep - b.ep);
  if (need.length === 0) return null;
  const target = (need.find((n) => n.canRejudge) ?? need[0]);
  const running = workbench?.jobs?.running ?? [];
  let reason: string | null = null;
  if (running.some((j) => isRejudgeJob(j))) reason = RUNNING_REASON;
  else if (running.length > 0) reason = BUSY_REASON;
  else if (!target.canRejudge) reason = WRITER_UNKNOWN_REASON;
  return { episodes: need.map((n) => n.ep), target: target.ep, sentence: recheckSentence(need), disabled: reason !== null, disabledReason: reason };
};
